import { render } from "./PostsIndex.vue?vue&type=template&id=61416a65"
import script from "./PostsIndex.vue?vue&type=script&lang=js"
export * from "./PostsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__